import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { SharedDialogComponent } from './shared-dialog/shared-dialog.component';
import { AskerComponent } from './asker/asker.component';

@Injectable()
export class UIService {
  loadingStatedChanged = new Subject<boolean>();

  constructor(private snackbar: MatSnackBar, private dig: MatDialog) {

  }

  config: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  }

  showSnackbar(message, action, duration, success ) {
    this.config.duration = duration;
    if (success) {
      this.config['panelClass'] = ['notification', 'success'];
    }
    else {
      this.config['panelClass'] = ['notification', 'warn'];
    }
    this.snackbar.open(message, action, this.config );
  }

  openDialog(e: { head: string, msg: string }) {
    return this.dig.open(SharedDialogComponent, { data: e })
  }

  openAsker(e: { head: string, ask: string }) {
    return this.dig.open(AskerComponent, { data: e })
  }

  formatAMPMT(dates) {
    var date: any = new Date(dates);
    var hours: any = date.getHours();
    var minutes: any = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  dateFormatter(date) {
    const today = new Date(date);
    const yyyy = today.getFullYear();
    let mm: any = today.getMonth() + 1; // Months start at 0!
    let dd: any = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return dd + '/' + mm + '/' + yyyy;
  }



}
